import React from 'react';
import { Link } from 'react-router-dom';
import { LogoMark } from './LogoMark';
export function Footer() {
  return <footer className="bg-ink border-t border-white/5 py-16" data-id="element-103">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-104">
        <div className="grid md:grid-cols-4 gap-12 mb-12" data-id="element-105">
          <div className="md:col-span-2" data-id="element-106">
            <div className="flex items-center gap-3 mb-4" data-id="element-107">
              <LogoMark size={36} data-id="element-108" />
              <div className="flex items-baseline gap-1.5" data-id="element-109">
                <span className="font-semibold text-xl text-bone" data-id="element-110">Masube</span>
                <span className="text-xs font-medium text-mint uppercase tracking-[0.2em]" data-id="element-111">
                  Settle
                </span>
              </div>
            </div>
            <p className="text-bone-dim max-w-sm leading-relaxed" data-id="element-112">
              The USSD, SMS, and WhatsApp payment layer for South African retail
              accounts.
            </p>
          </div>

          <div data-id="element-113">
            <div className="text-xs font-medium text-muted uppercase tracking-[0.2em] mb-4" data-id="element-114">
              Product
            </div>
            <ul className="space-y-3 text-sm" data-id="element-115">
              <li data-id="element-116">
                <a href="#how-it-works" className="text-bone-dim hover:text-mint transition-colors" data-id="element-117">
                  
                  How it works
                </a>
              </li>
              <li data-id="element-118">
                <a href="#benefits" className="text-bone-dim hover:text-mint transition-colors" data-id="element-119">
                  
                  Benefits
                </a>
              </li>
              <li data-id="element-120">
                <a href="#try-it" className="text-bone-dim hover:text-mint transition-colors" data-id="element-121">
                  
                  Live demo
                </a>
              </li>
              <li data-id="element-122">
                <a href="#security" className="text-bone-dim hover:text-mint transition-colors" data-id="element-123">
                  
                  Security
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-124">
            <div className="text-xs font-medium text-muted uppercase tracking-[0.2em] mb-4" data-id="element-125">
              Company
            </div>
            <ul className="space-y-3 text-sm" data-id="element-126">
              <li data-id="element-127">
                <a href="#book-demo" className="text-bone-dim hover:text-mint transition-colors" data-id="element-128">
                  
                  Book a demo
                </a>
              </li>
              <li data-id="element-129">
                <Link to="/faq" className="text-bone-dim hover:text-mint transition-colors" data-id="element-130">
                  
                  FAQ
                </Link>
              </li>
              <li data-id="element-131">
                <a href="#" className="text-bone-dim hover:text-mint transition-colors" data-id="element-132">
                  
                  Careers
                </a>
              </li>
              <li data-id="element-133">
                <a href="#" className="text-bone-dim hover:text-mint transition-colors" data-id="element-134">
                  
                  Press
                </a>
              </li>
              <li data-id="element-135">
                <a href="#" className="text-bone-dim hover:text-mint transition-colors" data-id="element-136">
                  
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-137">
          <div className="text-sm text-muted" data-id="element-138">
            © {new Date().getFullYear()} Masube Settle (Pty) Ltd. Built with ❤️ by <a href="https://stasisgroup.co" target="_blank" rel="noopener noreferrer" className="text-mint transition-colors" data-id="element-139">
              Stasis Group PTY Ltd.
            </a>. All rights reserved.
          </div>
          <div className="flex gap-6 text-sm text-muted" data-id="element-140">
            <Link to="/privacy" className="hover:text-bone transition-colors" data-id="element-141">
              Privacy
            </Link>
            <Link to="/terms" className="hover:text-bone transition-colors" data-id="element-142">
              Terms
            </Link>
            <a href="#" className="hover:text-bone transition-colors" data-id="element-143">
              Status
            </a>
          </div>
        </div>
      </div>
    </footer>;
}